export function SiteFooter() {
  return (
    <footer
      style={{
        padding: '24px 16px 32px',
        textAlign: 'center',
        fontSize: 13,
        color: 'var(--v2-text-muted, #6b7280)',
        borderTop: '1px solid rgba(0,0,0,0.08)',
        marginTop: 32,
      }}
    >
      <a
        href="/sms-terms/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'underline', margin: '0 8px' }}
      >
        SMS Terms of Service
      </a>
      <span aria-hidden="true">·</span>
      <a
        href="/sms-privacy/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'underline', margin: '0 8px' }}
      >
        SMS Privacy Policy
      </a>
      <div style={{ marginTop: 8 }}>
        We use{' '}
        <a
          href="https://plausible.io/privacy-focused-web-analytics"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'inherit', textDecoration: 'underline' }}
        >
          Plausible Analytics
        </a>{' '}
        for cookieless, privacy-friendly visitor stats. No personal data is collected.
      </div>
    </footer>
  );
}
